import { combineReducers } from 'redux';
import { buildingActivitiesReducer } from './buildingActivitiesReducer';
import { userActivitiesReducer } from './userActivitiesReducer';

export const combinedReducers = combineReducers({
  buildingActivities: buildingActivitiesReducer,
  userActivities: userActivitiesReducer,
  // Add other reducers here if needed
});